import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Allergies: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path d="M29.474 21.426v-9.899" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M29.475 13.107a4.062 4.062 0 004.07-4.053A4.062 4.062 0 0029.475 5a4.062 4.062 0 00-4.07 4.054 4.062 4.062 0 004.07 4.053z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M40.906 40.13l7.543 6.446" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M50.335 52.24a4.062 4.062 0 004.07-4.054 4.062 4.062 0 00-4.07-4.053 4.062 4.062 0 00-4.07 4.053 4.062 4.062 0 004.07 4.054z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M39.95 29.796l9.685-2.227" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M52.055 31.067a4.062 4.062 0 004.07-4.054 4.062 4.062 0 00-4.07-4.054 4.062 4.062 0 00-4.07 4.054 4.062 4.062 0 004.07 4.053z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M23.48 40.3l-6.048 7.852" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M15.919 54.17a4.062 4.062 0 004.07-4.054 4.062 4.062 0 00-4.07-4.054 4.062 4.062 0 00-4.07 4.054 4.062 4.062 0 004.07 4.054z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M18.519 26.57l-9.157-3.846" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M7.07 25.82a4.062 4.062 0 004.07-4.054 4.062 4.062 0 00-4.07-4.054A4.062 4.062 0 003 21.766a4.062 4.062 0 004.07 4.053zM43.736 32.1c0 1.437-2.256 2.5-2.678 3.797-.421 1.298.744 3.521-.072 4.64-.815 1.12-3.275.679-4.41 1.5-1.136.822-1.447 3.28-2.795 3.715-1.347.434-3.012-1.373-4.453-1.373-1.44 0-3.152 1.792-4.452 1.373-1.3-.42-1.67-2.902-2.795-3.715-1.132-.821-3.586-.372-4.41-1.5-.825-1.128.364-3.298-.072-4.64-.437-1.342-2.678-2.36-2.678-3.798 0-1.437 2.256-2.5 2.678-3.797.421-1.298-.744-3.521.072-4.64.815-1.12 3.275-.68 4.41-1.5 1.136-.822 1.447-3.28 2.795-3.715 1.348-.435 3.012 1.372 4.452 1.372s3.153-1.792 4.453-1.372c1.3.42 1.67 2.902 2.794 3.714 1.124.813 3.587.372 4.411 1.5.825 1.128-.364 3.298.072 4.64.437 1.343 2.678 2.36 2.678 3.798z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M32.542 33.11c1.784 0 3.23-1.441 3.23-3.218a3.224 3.224 0 00-3.23-3.218 3.224 3.224 0 00-3.23 3.218 3.224 3.224 0 003.23 3.217zM25.187 37.697a2.41 2.41 0 01-2.411-2.402 2.41 2.41 0 012.411-2.402 2.41 2.41 0 012.412 2.402 2.41 2.41 0 01-2.412 2.402z"
                fill="#fff"
                stroke={props.color}
            />
        </Svg>
    );
};

export default React.memo(Allergies);
